import api from '@api';
import { call, put, takeEvery, select } from 'redux-saga/effects';
import {
    getUsersListFetch as getUsersListFetchAction,
    getUsersListFetchSuccess,
    getUsersListFetchFailure,
    activateUserFetchSuccess,
    activateUserFetchFailure,
    deactivateUserFetchSuccess,
    deactivateUserFetchFailure,
} from './reducer';
import { UsersListResType } from 'src/types/usersList';
import { RootStoreType } from 'src/types/store';
import translate from '@translate';

const getUsersListFetchRequest = async (all?: boolean) => {
    const res = await api('get', all ? 'api/secure/users/all' : 'api/secure/users');
    return res.data;
};

function* getUsersListFetch(action: { type: string }) {
    try {
        const permissions: string[] = yield select((state: RootStoreType) => state.user.data?.permissions);
        const all = !!permissions.includes('USER.ALLPROVIDERS.LIST');

        const response: UsersListResType = yield call((): any => getUsersListFetchRequest(all));

        yield put(getUsersListFetchSuccess(response));
    } catch (error) {
        yield put(getUsersListFetchFailure({ error }));
    }
}

export function* getUsersListFetchWatch() {
    yield takeEvery('usersList/getUsersListFetch', getUsersListFetch);
}

const activateUserFetchRequest = async (idUser: number) => {
    const res = await api('put', `api/secure/users/${idUser}/activate`);
    return res.data;
};

function* activateUserFetch(action: { type: string; payload: number }) {
    try {
        const response: UsersListResType = yield call((): any => activateUserFetchRequest(action.payload));

        yield put(
            activateUserFetchSuccess({
                ...response,
                messageSuccess: { title: translate('messages.uploaded'), text: translate('users.messages.userActive') },
            })
        );
        yield put(getUsersListFetchAction());
    } catch (error) {
        yield put(activateUserFetchFailure({ error }));
    }
}

export function* activateUserFetchWatch() {
    yield takeEvery('usersList/activateUserFetch', activateUserFetch);
}

const deactivateUserFetchRequest = async (idUser: number) => {
    const res = await api('put', `api/secure/users/${idUser}/deactivate`);
    return res.data;
};

function* deactivateUserFetch(action: { type: string; payload: number }) {
    try {
        const response: UsersListResType = yield call((): any => deactivateUserFetchRequest(action.payload));

        yield put(
            deactivateUserFetchSuccess({
                ...response,
                messageSuccess: {
                    title: translate('messages.uploaded'),
                    text: translate('users.messages.userDeactive'),
                },
            })
        );
        yield put(getUsersListFetchAction());
    } catch (error) {
        yield put(deactivateUserFetchFailure({ error }));
    }
}

export function* deactivateUserFetchWatch() {
    yield takeEvery('usersList/deactivateUserFetch', deactivateUserFetch);
}
